/**
 * `value` when it is an http(s) URL, so it can be a link's href; undefined otherwise, and the caller
 * shows it as plain text. Activity metadata is not ours: a form's embed URL comes from whoever
 * loads the public form, and a `javascript:` href would run here when staff click it.
 */
export function webHref(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  try {
    const { protocol } = new URL(value);
    return protocol === 'http:' || protocol === 'https:' ? value : undefined;
  } catch {
    return undefined;
  }
}
